import './InfoPanel.css';
import '../typography.css';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';

export interface InfoPanelProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * In-place info panel: takes over the widget body rather than floating above
 * it, so it inherits the widget's own bounds on whatever page embeds it.
 */
const InfoPanel = ({ title, onClose, children }: InfoPanelProps) => {
  return (
    <div className="info-panel" aria-label={title}>
      <div className="info-panel-header">
        <span className="info-panel-title body-m-bold">{title}</span>
        <button
          type="button"
          className="info-panel-close"
          aria-label="Close"
          onClick={onClose}
        >
          <CloseIcon />
        </button>
      </div>
      <div className="info-panel-body">{children}</div>
    </div>
  );
};

export default InfoPanel;
